import { uploadImageSchema } from '@Containers/UploadImageFormFields/validators';
import {
  EMPTY_FIELD_MESSAGE,
  validateEditorEn,
  validateSpace,
  validateSpaceTextInput,
  validateTextEn,
} from '@Utils/validation';
import { z } from 'zod';

enum BUSINESS_VALUE_CHAIN_MESSAGE {
  INTRODUCTION_EN = 'กรุณาระบุคำบรรยายห่วงโซ่คุณค่าธุรกิจเป็นภาษาอังกฤษ',
  REMARK_EN = 'กรุณาระบุหมายเหตุห่วงโซ่คุณค่าธุรกิจเป็นภาษาอังกฤษ',
  DESCRIPTION = 'กรุณาระบุคำอธิบายภาพรวมกิจกรรมในห่วงโซ่คุณค่าธุรกิจ',
  DESCRIPTION_EN = 'กรุณาระบุอธิบายภาพรวมกิจกรรมในห่วงโซ่คุณค่าธุรกิจเป็นภาษาอังกฤษ',
  ASSETS = 'กรุณาเลือกไฟล์ภาพห่วงโซ่คุณค่าธุรกิจ',
  DESCRIPTION_ASSETS_EN = 'กรุณาระบุชื่อรูปภาพ/หัวข้อ/คำอธิบายเพิ่มเติมเป็นภาษาอังกฤษ',
}

const IUploadImageSchema = uploadImageSchema({
  assets: BUSINESS_VALUE_CHAIN_MESSAGE.ASSETS,
  descriptionAssetsEn: BUSINESS_VALUE_CHAIN_MESSAGE.DESCRIPTION_ASSETS_EN,
});

export const BusinessValueChainSchema = z.object({
  introduction: z.object({
    descriptionTh: z
      .string()
      .refine(validateSpace, EMPTY_FIELD_MESSAGE.SPACE_BAR)
      .nullable()
      .optional(),
    descriptionEn: z
      .string()
      .regex(validateEditorEn, BUSINESS_VALUE_CHAIN_MESSAGE.INTRODUCTION_EN)
      .refine(validateSpace, EMPTY_FIELD_MESSAGE.SPACE_BAR)
      .nullable()
      .optional(),
  }),
  descriptionTh: z
    .string({
      message: BUSINESS_VALUE_CHAIN_MESSAGE.DESCRIPTION,
    })
    .refine(validateSpace, EMPTY_FIELD_MESSAGE.SPACE_BAR),
  assets: z.array(IUploadImageSchema),
  descriptionEn: z
    .string({ message: BUSINESS_VALUE_CHAIN_MESSAGE.DESCRIPTION })
    .regex(validateEditorEn, BUSINESS_VALUE_CHAIN_MESSAGE.DESCRIPTION_EN)
    .refine(validateSpace, EMPTY_FIELD_MESSAGE.SPACE_BAR),
  remark: z.object({
    descriptionTh: z
      .string()
      .refine(validateSpaceTextInput, EMPTY_FIELD_MESSAGE.SPACE_BAR)
      .nullable()
      .optional(),
    descriptionEn: z
      .string()
      .regex(validateTextEn, BUSINESS_VALUE_CHAIN_MESSAGE.REMARK_EN)
      .refine(validateSpaceTextInput, EMPTY_FIELD_MESSAGE.SPACE_BAR)
      .nullable()
      .optional(),
  }),
});
